export const RANKS = "23456789TJQKA";
export const SUITS = ["s", "h", "d", "c"];
export const SUIT_SYMBOL = { s: "♠", h: "♥", d: "♦", c: "♣" };

export const rankOf = (c) => (c >> 2) + 2;
export const suitOf = (c) => c & 3;
export const rankChar = (r) => RANKS[r - 2];
export const cardText = (c) => rankChar(rankOf(c)) + SUIT_SYMBOL[SUITS[suitOf(c)]];
export const cardsText = (cs) => cs.map(cardText).join(" ");

export const newDeck = () => Array.from({ length: 52 }, (_, i) => i);

// Cryptographically secure, unbiased random integer in [0, n)
export function randInt(n) {
  const buf = new Uint32Array(1);
  const limit = Math.floor(0x100000000 / n) * n;
  let x;
  do {
    crypto.getRandomValues(buf);
    x = buf[0];
  } while (x >= limit);
  return x % n;
}

// Fisher-Yates with crypto RNG: every deal is fair and uniformly random
export function shuffle(deck) {
  const d = deck.slice();
  for (let i = d.length - 1; i > 0; i--) {
    const j = randInt(i + 1);
    [d[i], d[j]] = [d[j], d[i]];
  }
  return d;
}

export const fmt = (n) => Math.round(n).toLocaleString("en-US");
